export { default } from './ListItemText';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ListItemText/index.js
// module id = 1300
// module chunks = 0